if (!customElements.get('lite-gallery')) {
  (function($) {
    var $ = jQuery = $;
    class LiteGallery extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.section;
        if (this.dataset.block) {
          this.sectionId = `${this.dataset.section}${this.dataset.block}`;
        }

        let galleryOptions = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.productGallery = this.querySelector(`.product-single__gallery-${this.sectionId}`);
        const productVariants = document.getElementById(`VariantSelect-${this.sectionId}`);
        let options;
        let currentVariant;
        let mediaId = null;

        if (productVariants) {
          options = productVariants.productData ? productVariants.productData.options : null;

          currentVariant = productVariants.currentVariant;
          if (currentVariant && currentVariant.featured_media) {
            mediaId = `${this.sectionId}-${currentVariant.featured_media.id}`;
          }
        }

        const optionsSlider = {
          optionsGallery: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true
          },
          galleryNav: false,
          optionsNav: {
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0px',
            focusOnSelect: true,
            arrows: false,
            draggable: false,
            swipe: false,
            infinite: false,
            vertical: false,
            variableWidth: false,
            adaptiveHeight: false
          }
        }

        if (!galleryOptions) {
          galleryOptions = optionsSlider;
        } else {
          // Override problematic settings
          if (galleryOptions.optionsNav) {
            galleryOptions.optionsNav.centerMode = false;
            galleryOptions.optionsNav.infinite = false;
            galleryOptions.optionsNav.variableWidth = false;
            galleryOptions.optionsNav.adaptiveHeight = false;
          }
        }

        this.initBreakpoints();
        if (this.productGallery) {
          this.initGallerySlider(galleryOptions);
          this.setActiveMedia(mediaId, options, currentVariant);
        }
      }

      initBreakpoints() {
        enquire.register('screen and (min-width: 1280px)', {
          match: () => {
            this.bpSmall = false;
          },
          unmatch: () => {
            this.bpSmall = true;
          }
        });

        enquire.register("screen and (min-width: 1001px)", {
          match : () => {
            this.blockSlide3DModel = true;
          }
        });
      }

      camelize(str) {
        return str.replace(/\W+(.)/g, function(match, chr) {
          return chr.toUpperCase();
        });
      }

      setActiveMedia(mediaId, productOptions, currentVariant) {
        const $slickGallery = $(`.product-single__gallery-${this.sectionId}`);
        let slideIndex = 0;
        let colorValue;

        if (productOptions && currentVariant) {
          const productSwatchesArray = this.dataset.productSwatches.split(',');

          productOptions.forEach((option, i) => {
            const optionName = option.toLowerCase().trim();
            const productSwatch = productSwatchesArray.find((value) => value.trim() === optionName );

            if (productSwatch) {
              colorValue = currentVariant.options[i];
            }
          });
        }

        if (mediaId) {
          const activeMedia = this.productGallery.querySelector(`[data-media-id="${ mediaId }"]`);
          if (activeMedia) {
            slideIndex = activeMedia.dataset.slickIndex;
          }
        }

        $slickGallery.slick('slickGoTo', slideIndex, true);

        const activeMedia = this.productGallery.querySelector(`[data-slick-index="${ $slickGallery.slick('slickCurrentSlide') }"]`);
        this.playActiveMedia(activeMedia);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        if (activeItem) {
          const video = activeItem.querySelector('video');

          if (video) {
            video.play();
          }

          const deferredMedia = activeItem.querySelector('.deferred-media:not(product-model)');
          if (deferredMedia && deferredMedia.dataset.preventAutoplay) return;
          if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
        }
      }

      scrollThumbnailToActive(nextSlide) {
        const $thumbnailContainer = $(`.product-single__thumbnails-${this.sectionId}`);
        
        // Don't scroll if slider is not initialized or if we have 5 or fewer slides
        if (!$thumbnailContainer.hasClass('slick-initialized')) return;
        
        const totalSlides = $thumbnailContainer.find('.slick-slide:not(.slick-cloned)').length;
        const slidesToShow = $thumbnailContainer.slick('slickGetOption', 'slidesToShow');
        
        // If total slides are less than or equal to slidesToShow, don't scroll
        if (totalSlides <= slidesToShow) return;
        
        const currentThumbSlide = $thumbnailContainer.slick('slickCurrentSlide');
        
        // Calculate visible range
        const firstVisible = currentThumbSlide;
        const lastVisible = currentThumbSlide + slidesToShow - 1;
        
        let targetSlide = currentThumbSlide;
        
        // Scroll forward if next slide is beyond visible range
        if (nextSlide > lastVisible) {
          targetSlide = Math.min(nextSlide - slidesToShow + 1, totalSlides - slidesToShow);
        }
        // Scroll backward if next slide is before visible range
        else if (nextSlide < firstVisible) {
          targetSlide = nextSlide;
        }
        
        // Only scroll if target is different from current
        if (targetSlide !== currentThumbSlide && targetSlide >= 0) {
          // Use setTimeout to prevent layout conflicts with asNavFor
          setTimeout(() => {
            if ($thumbnailContainer.hasClass('slick-initialized')) {
              $thumbnailContainer.slick('slickGoTo', targetSlide, false);
            }
          }, 10);
        }
      }

      initGallerySlider(options) {
        const self = this;
        const $productGallery = $(`.product-single__gallery-${this.sectionId}`);
        const optionsGallery = options.optionsGallery;
        let $galleryNav;
        let optionsNav;

        if (options.galleryNav) {
          optionsNav = options.optionsNav;
          $galleryNav = $(`.product-single__thumbnails-${this.sectionId}`);
          
          if ($galleryNav.length > 0) {
            optionsGallery.asNavFor = `.product-single__thumbnails-${this.sectionId}`;
            optionsNav.asNavFor = `.product-single__gallery-${this.sectionId}`;
          }
        }

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);

        if ($galleryNav && $galleryNav.length > 0) {
          const $thumbnailsItem = $galleryNav.find('.product-single__thumbnails-item');
          const thumbnailCount = $thumbnailsItem.length;
          const slidesToShow = optionsNav.slidesToShow || 5;

          // Initialize thumbnail slider
          $galleryNav.slick(optionsNav);
          
          // Add class for styling when we have 5 or fewer thumbnails
          if (thumbnailCount <= slidesToShow) {
            $galleryNav.addClass('nav-set-translation');
            $galleryNav.addClass('thumbnails-no-scroll');
          }

          $thumbnailsItem.each(function(index, elem) {
            elem.classList.remove('product-single__thumbnails--hide');
          });

          // Force proper positioning after initialization
          setTimeout(() => {
            $galleryNav.slick('setPosition');
            // Only go to slide 0 if we have more than slidesToShow thumbnails
            if (thumbnailCount <= slidesToShow) {
              $galleryNav.slick('slickGoTo', 0, false);
            }
          }, 100);
        }

        // Auto-scroll thumbnails when main gallery changes
        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          self.scrollThumbnailToActive(nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });

        window.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') {
            $productGallery.slick('slickPrev');
          } else if (event.code === 'ArrowRight') {
            $productGallery.slick('slickNext');
          }
        });

        const resizeObserver = new ResizeObserver((entries) => {
          if ($galleryNav && $galleryNav.length > 0) {
            $galleryNav.slick('setPosition');
          }
        });

        resizeObserver.observe(this);

        // Accessibility concerns not yet fixed in Slick Slider
        $(`.product-single__wrapper-${this.sectionId}`)
          .find('.slick-list')
          .removeAttr('aria-live');
        $(`.product-single__wrapper-${this.sectionId}`)
          .find('.slick-disabled')
          .removeAttr('aria-disabled');
      }
    }

    customElements.define('lite-gallery', LiteGallery);
  })(theme.jQuery);
}